import React, { Fragment } from 'react';
import { Container, Row, Col, Button, Progress } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import '../../Steps/steps.scss';
import Description from './Description';
import ImageUpload from './ImageUpload';
import ContinueButton from './ContinueButton';

function ProjectDetails() {
	const navigate = useNavigate();

    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back" onClick={() => navigate(-1)}></Button>
		    					<h3>About your project</h3>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={60}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<h1 className="m-b-30">Tell us about<br/> your project</h1>
		    				<Description/>
		    			</Col>
			    	</Row>
		    	</Container>

	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<span className="text-label m-t-40">Upload photos of your space</span><span className="question-tooltip"></span>
		    			</Col>
			    	</Row>
			    </Container>
				<ImageUpload/>
			    <Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="d-grid gap-2 m-t-40">
								<ContinueButton color="primary" size="lg"/>
			    			</div>
		    			</Col>
			    	</Row>
			    	
		    	</Container>

		    	{/*BUTTON "DONE" STEP 3B*/}
    			{/*<Button color="secondary" size="lg" className="button-fixed-fullwidth">Done</Button>*/}

    			{/*MODAL*/}
    			{/*<section className="modal-from-bottom">
    				<div class=Name"backshadow"></div>
    				<div class=Name"modal-content">
    					<Container className="builde-cont">
    						<Row>
								<Col xs={{size: 12}} className="text-center">
									<img src={Photos} alt="Upload file" />
									<h4>You can upload photos of the current status of your project and references as well</h4>

									<Button color="primary" size="lg">Upload</Button>
									<Button color="secondary" size="lg" className="m-t-15">Continue without change</Button>
								</Col>
    						</Row>
    					</Container>
    				</div>
    			</section>*/}
	    	</form>
    	</Fragment>
    );
}

export default ProjectDetails;